import { useViewer } from '@treams/treams-hooks';
import { useDevelopmentPlanQuery } from '@treams/treams-network';

import DevelopmentPlan from './components/DevelopmentPlan';

export default function DevelopmentPlanRoute() {
	const viewer = useViewer();
	const query = useDevelopmentPlanQuery({
		variables: { userID: viewer!.id },
	});

	return (
		<>
			{query.loading && <DevelopmentPlan.Skeleton />}
			{query.data?.user && (
				<DevelopmentPlan onSave={() => query.refetch()} user={query.data.user} />
			)}
		</>
	);
}
